import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { tutoringPath } from "@outschool/routes";
import { TrackingPage } from "@outschool/ui-legacy-component-library";
import React from "react";

import ogImagePath from "../../images/tutoring/og-image.jpg";
import * as Routes from "../../shared/Routes";
import HeaderTags from "../components/HeaderTags";
import SimpleLayout from "../components/layouts/SimpleLayout";
import TutoringPageBody from "../components/tutoring/TutoringPageBody";

export default function TutoringPage() {
  const { t } = useTranslation("client\\routes\\TutoringPage");

  return (
    <SimpleLayout hideReviewReminder showSearchBox={false}>
      <HeaderTags
        title={t("Tutoring")}
        meta={[
          {
            property: "og:title",
            content: t(
              "Tutoring on your terms: 1-on-1 personalized instruction as unique as your kid"
            )
          },
          {
            name: "description",
            content: t(
              "Save time and gas with live, online tutoring from the comfort of your home. Work with expert educators who bring out the best in your kid."
            )
          },
          {
            property: "og:description",
            content: t(
              "Save time and gas with live, online tutoring from the comfort of your home. Work with expert educators who bring out the best in your kid."
            )
          },
          {
            property: "og:image",
            content: ogImagePath
          }
        ]}
        canonical={Routes.pathToUrl(tutoringPath())}
      />
      <TrackingPage name="tutoringPage" uniqueId={"tutoring-page"}>
        {setImpressionNode => (
          <Box
            ref={(node: $TSFixMe) => setImpressionNode(node)}
            sx={{
              overflow: "hidden"
            }}
          >
            <TutoringPageBody />
          </Box>
        )}
      </TrackingPage>
    </SimpleLayout>
  );
}
